import React from 'react';
import { useRediscoveryApplication } from 'talent_matching/talent_rediscovery/hooks/use_rediscovery_applications';
import { Stack } from '@grnhse/seedling/lib/birch/layouts/stack_v2';
import {
  InlineMarkdown,
  SecondaryBody,
} from '@grnhse/seedling/lib/birch/typography';
import { withLocalePrefix } from 'shared/utils/translation';

const t = withLocalePrefix('talent_matching.rediscovery.table.summary_cell');

export const scorecardSummaryText = (
  percentage: number | null,
  bold = false
): string => {
  const prefix = `scorecard_summary${bold ? '.bold' : ''}`;

  if (percentage === null) {
    return t(`${prefix}.no_scorecards`);
  }
  if (percentage === 100) {
    return t(`${prefix}.all_positive`);
  }
  if (percentage >= 75) {
    return t(`${prefix}.mostly_positive`);
  }
  if (percentage >= 50) {
    return t(`${prefix}.half_positive`);
  }
  if (percentage > 0) {
    return t(`${prefix}.few_positive`);
  }
  return t(`${prefix}.none_positive`);
};

const SummaryCell = ({ applicationId }: { applicationId: number }) => {
  const { application } = useRediscoveryApplication(applicationId);

  if (!application) {
    return null;
  }

  return (
    <Stack
      spacing={0.5}
      alignContent="flex-start"
      sx={{
        padding: 1,
        paddingLeft: 0,
        height: '100%',
      }}
    >
      {application.currentStage && (
        <SecondaryBody>
          <InlineMarkdown
            text={t('reached', { stage: application.currentStage.name })}
          />
        </SecondaryBody>
      )}
      {application.milestone && (
        <SecondaryBody>
          <InlineMarkdown
            text={t('milestone', { milestone: application.milestone })}
          />
        </SecondaryBody>
      )}
      {application.rejectionReason && (
        <SecondaryBody>
          <InlineMarkdown
            text={t('rejected_for', {
              reason: application.rejectionReason,
            })}
          />
        </SecondaryBody>
      )}
      <SecondaryBody>
        <InlineMarkdown
          text={scorecardSummaryText(application.positiveRatingPercentage)}
        />
      </SecondaryBody>
    </Stack>
  );
};

export default SummaryCell;
